import {UseStorageOptions, UseStorageResult, useStorage} from './useStorage';

export function useSessionStorage<T>(key: string, initialValue?: T, options?: UseStorageOptions): UseStorageResult<T> {
  return useStorage<T>(globalThis.sessionStorage, key, initialValue, options);
}
